import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';

// style
import tableIcons from '../../../components/table/MaterialTableIcon';
// Utils
import exportCsv from '../../../utils/export/Csv';
import EwsColor from '../../../components/color/ews/EwsColor';

export default function EarlyWarningDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('ชื่อหมู่บ้าน'),
            title_export: t('ชื่อหมู่บ้าน'),
            field: 'name',
            type: 'string',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.name}`,
          },
          {
            title: t('ประเภทการเตือน'),
            title_export: t('ประเภทการเตือน'),
            field: 'status',
            type: 'string',
            align: 'center',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => {
              const status = EwsColor(row.status);
              return (
                <Box
                  borderRadius={3}
                  style={{
                    align: 'center',
                    textAlign: 'center',
                    padding: '5px',
                    margin: '0 auto',
                    width: '65px',
                    backgroundColor: status.color.statusColor,
                    color: '#FFFFFF',
                  }}
                >
                  {row.status}
                </Box>
              );
            },
          },
          {
            title: t('วันเผยแพร่'),
            title_export: t('วันเผยแพร่'),
            field: 'pubDate',
            type: 'date',
            align: 'center',
            width: 100,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${moment(row.pubDate).format('YYYY-MM-DD HH:MM')} น.`,
          },
        ]}
        data={datas}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: isExport,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

EarlyWarningDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
